import {Injectable} from '@angular/core';
import {
  HttpClient,
  HttpHeaders
} from '@angular/common/http';

import {environment} from '../environments/environment';
import {ScreenService} from '../app/services/screen.service';


@Injectable()
export class RestProvider {
  apiUrl = environment.apiUrl;
  addressesUrl = environment.apiAddressUrl;
  backendUrl = environment.apibackendUrl;
  usersUrl = environment.apiUsersUrl;
  headerOptions: any;
  headerAddresses: any;
  headerBackend: any;
  headerUser: any;

  users: any;

  constructor(
    private http: HttpClient,
    private screenService: ScreenService,
  ) {
    if (screenService.getIsBrowser()) {
      this.setHeaders();
    }

  }


  getAllLandingsDetails() {
    return this.http.get(this.apiUrl + '/landings', this.headerOptions);
  }

  getLandingsDetails(name) {
    return this.http.get(this.apiUrl + '/landings?name_contains=' + name, this.headerOptions);
  }

  getStaticPageDetails(insee) {
    return this.http.get(this.backendUrl + '/city/static/pages?inseeCode=' + insee, this.headerBackend).map(
      data => {
        return data;
      },
      err => {
        return err;
      }
    );
  }

  // sendMailContact(data) {
  //   return this.http.post(this.usersUrl + '/emails/contact', data, this.headerUser);
  // }

  sendMailObservatoire(data) {
    return this.http.post(this.usersUrl + '/emails/contact/observatoire', data, this.headerUser);
  }

  private setHeaders() {

    const adminHeaders = new HttpHeaders({
      //'Authorization': 'Bearer ' + environment.strapiKey
    });
    const AddressesHeaders = new HttpHeaders({
      'Authorization': 'Basic ' + btoa(environment.apiAddressCredentials[0] + ':' + environment.apiAddressCredentials[1])
    });
    const headerBackend = new HttpHeaders({
      'Authorization': 'Basic ' + btoa(environment.apibackendCredentials[0] + ':' + environment.apibackendCredentials[1])
    });

    const headerUser = new HttpHeaders({
      'Authorization': 'Basic ' + btoa(environment.apiUsersCredentials[0] + ':' + environment.apiUsersCredentials[1])
    });

    this.headerOptions = {headers: adminHeaders};
    this.headerAddresses = {headers: AddressesHeaders};
    this.headerBackend = {headers: headerBackend};
    this.headerUser = {headers: headerUser};

  }
}
